import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import axios from '../../redux/axios';

export interface DocumentHighlightsState {
    documentData: any,
    documentDetailData: any,
    isdocumentDetailData: any,
    response: any,
    imagePath: any,
    encPdfData: any,
    profileImagePath: any,
    isFetching: boolean,
    isDocuementDataSuccess: boolean,
    encPdfDataSuccess: boolean,
    isAddResponse: boolean,
    isError: boolean,
    errorMessage: any,
}


const initialState: DocumentHighlightsState = {
    documentData: [],
    documentDetailData: {},
    isdocumentDetailData: false,
    response: [],
    encPdfData: [],
    imagePath: '',
    profileImagePath: '',
    isFetching: false,
    isDocuementDataSuccess: false,
    isAddResponse: false,
    encPdfDataSuccess: false,
    isError: false,
    errorMessage: '',
};

export const AdddocumentFileit = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/chd/addDocumentFileit', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });
  
    let data = response.data;
    //console.log(data.data)
  //  dispatch(setAddState(data));
    return data;
  };

export const getDocumentHighlights: any = createAsyncThunk(
    'documents/highlights',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;

            let response = await axios({
                url: `/api/comment/comment?docId=${udata}&isHighLight=true`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);




export const getOcr = (myData: any) => async () => {
    
    let textData = myData;
    axios.post('http://localhost:7000/api/getocr', textData)
  .then(response => {
    // console.log('Response:', response.data);
    let data = response.data;
    console.log(data,'from OCR')
    setTimeout(()=>{
        return data;
    },3000)
    
  })
  .catch(error => {
    console.error('Error:', error);
  });
};




export const getIncryptedPDF: any = createAsyncThunk(
    'api/clerk/givePdf?pdfName',
    async (udata, thunkAPI) => {
        try {
            const { auth }: any = thunkAPI.getState()
            let tokenStr = auth.user.token;

            let response = await axios({
                url: `/api/clerk/givePdf?pdfName=${udata}`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            let error: any = err;
            if (!error.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(error.response.data)
        }
    }
);



export const DocumentHighlightsSlice = createSlice({
    name: 'documenthighlights',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        setAddState: (state, { payload }) => {
            state.isAddResponse = true;
            state.response = payload.data;
        },
        
        unsetAddState: (state) => {
            state.isAddResponse = false;
        },
        setDocumentDetailState: (state, { payload }) => {
            state.isdocumentDetailData = true;
            state.documentDetailData = payload.data;
        },
        unsetDocumentDetailState: (state) => {
            state.isdocumentDetailData = false;
        },
        clearStateSlice: (state, { payload }: PayloadAction) => {
            // state.stageData = [];
            state.isFetching = false;
            state.isDocuementDataSuccess = false;
            state.isError = false;
            state.errorMessage = '';
            state.imagePath = '';
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [getDocumentHighlights.fulfilled]: (state, { payload }) => {
            const { data } = payload.data;
            state.documentData = data;
            state.imagePath = payload.data.imagePath;
            state.profileImagePath = payload.data.profileImagePath;
            state.isFetching = false;
            state.isDocuementDataSuccess = true;
            return state;
        },

        [getDocumentHighlights.pending]: (state) => {
            state.isFetching = false;
        },

        [getDocumentHighlights.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        },



        [getIncryptedPDF.fulfilled]: (state, { payload }) => {

            state.encPdfData = payload;
            state.isFetching = false;
            state.encPdfDataSuccess = true;
            return state;
        },

        [getIncryptedPDF.pending]: (state) => {
            state.isFetching = false;
        },

        [getIncryptedPDF.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }





    },
});

export const { setAddState,  unsetAddState, clearStateSlice, setDocumentDetailState, unsetDocumentDetailState } = DocumentHighlightsSlice.actions;

export function clearState() {

    return async (dispatch: any) => {
        dispatch(clearStateSlice());
    };
}

export function clearAddResponseState() {

    return async (dispatch: any) => {
        dispatch(unsetAddState());
    }
}

export function unsetDocumentDetailStateAsync() {

    return async (dispatch: any) => {
        dispatch(unsetDocumentDetailState());
    }
}

export const AddHighlightsAsyn = (bdata: any) => async (dispatch: any, getState: any) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/comment/comment', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });

    let data = response.data;
    //console.log(data.data)
    dispatch(setAddState(data));
    return data;
};


export const getDocumentDetailAsyn = (pdata: any) => async (dispatch: any, getState: any) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
        let response = await axios({
            url: `/api${userType}/document/detailed?processId=${pdata}`,
            method: 'get',
            //timeout: 8000,
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        dispatch(setDocumentDetailState(data));
        return data;
        // console.log(data.data)
        //dispatch(getAllUserDepartments(data));
    } catch (error) {
        const err: any = error;
        return err.response.data;
    }
};


export const getDocumentDetailV2Asyn = (pdata: any) => async (dispatch: any, getState: any) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        // let userType = auth.user.userType == 'CHD' ? 'chd' : auth.user.userType == "DD's & AD's" ? 'DDsAndAds' : 'clerk';
        let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
        let response = await axios({
            url: `/api${userType}/v2/document/detailed?processId=${pdata}`,
            method: 'get',
            //timeout: 8000,
            headers: {
                //'Content-Type': 'application/json',
                "Authorization": `Bearer ${tokenStr}`
            }
        })

        let data = response.data;
        dispatch(setDocumentDetailState(data));
        return data;
        // console.log(data.data)
        //dispatch(getAllUserDepartments(data));
    } catch (error) {
        const err: any = error;
        return err.response.data;
    }
};


export const pdfNewProcessAsyn = (docId: any) => async (dispatch: any, getState: any) => {
    try {
        const { auth } = getState()
        let tokenStr = auth.user.token;
        let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
        const response = await axios.get(`/api${userType}/pdfNewProcess?doc_id=${docId}`, { headers: { "Authorization": `Bearer ${tokenStr}` } });

        let data = response.data;
        return data;
    } catch (error) {
        const err: any = error;
        return err.response.data;
    }
};

export const EncrptyPdfDataDelAsyn = (bdata: any) => async (dispatch: any, getState: any) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    let userType = auth.user.userType == 'CHD' ? '/chd' : auth.user.userType == "DD's & AD's" ? '/DDsAndAds' : auth.user.userType == "Clerk" ? '/clerk' : "";
    let response = await axios({
        url: `/api/clerk/removePdf?pdfName=${bdata}`,
        method: 'delete',
        //timeout: 8000,
        headers: {
            //'Content-Type': 'application/json',
            "Authorization": `Bearer ${tokenStr}`
        }
    })
    let data = response.data;
    return data;
};

export const DocumentHighlightsSelector = (state: any) => state.documenthighlights;

export default DocumentHighlightsSlice.reducer;
